import { render, staticRenderFns } from "./AstralFSN_document.vue?vue&type=template&id=56b3ea7e&scoped=true&"
import script from "./AstralFSN_document.vue?vue&type=script&lang=js&"
export * from "./AstralFSN_document.vue?vue&type=script&lang=js&"
import style0 from "./AstralFSN_document.vue?vue&type=style&index=0&id=56b3ea7e&scoped=true&lang=css&"
import style1 from "./AstralFSN_document.vue?vue&type=style&index=1&id=56b3ea7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b3ea7e",
  null
  
)

export default component.exports